'use client';
import cn from 'classnames';
import styles from './Chip.module.scss';

type ChipProps = {
  className?: string;
  text: string;
  onDelete?: () => void;
};

export function Chip({ className, text, onDelete }: ChipProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <span className={styles.text}>{text}</span>
      {onDelete && (
        <img
          onClick={onDelete}
          className={styles.delete}
          src="/svg/close-gray.svg"
          alt="delete"
        />
      )}
    </div>
  );
}
